import { render, staticRenderFns } from "./EventListSlider.vue?vue&type=template&id=4c5a88bc&scoped=true"
import script from "./EventListSlider.vue?vue&type=script&lang=js"
export * from "./EventListSlider.vue?vue&type=script&lang=js"
import style0 from "./EventListSlider.vue?vue&type=style&index=0&id=4c5a88bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5a88bc",
  null
  
)

export default component.exports